export type NullableFields<T> = {
  [P in keyof T]: T[P] | null
}

export const isString = (data: unknown): data is string => typeof data === 'string'
